export default __webpack_public_path__ + "static/media/student-manipulatives-example.642ad873.gif";